let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8NZXA")).then(() => parcelRequire('3u7xR'));